import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ParallaxModule } from '../../parallax.module';
import { PipeModule } from '../../pipes/pipe.module';
import { BuildingBlockComponent } from './building-block.component';
import { CallToActionComponent } from './call-to-action/call-to-action.component';
import { HeadingComponent } from './heading/heading.component';
import { ImageListComponent } from './image-list/image-list.component';
import { ImageParagraphComponent } from './image-paragraph/image-paragraph.component';
import { ImageSpotlightComponent } from './image-spotlight/image-spotlight.component';
import { ImageComponent } from './image/image.component';
import { LiveProjectComponent } from './live-project/live-project.component';
import { ParagraphComponent } from './paragraph/paragraph.component';
import { QuoteComponent } from './quote/quote.component';
import { SpacerComponent } from './spacer/spacer.component';
import { SubheadingComponent } from './subheading/subheading.component';
import { TitleComponent } from './title/title.component';
import { VideoComponent } from './video/video.component';

@NgModule({
    imports: [
        CommonModule,
        PipeModule,
        ParallaxModule,
        RouterModule,
    ],
    declarations: [
        BuildingBlockComponent,
        CallToActionComponent,
        HeadingComponent,
        ImageComponent,
        ImageListComponent,
        ImageParagraphComponent,
        ImageSpotlightComponent,
        ParagraphComponent,
        QuoteComponent,
        SpacerComponent,
        SubheadingComponent,
        TitleComponent,
        VideoComponent,
        LiveProjectComponent,
    ],
    entryComponents: [
        CallToActionComponent,
        HeadingComponent,
        ImageComponent,
        ImageListComponent,
        ImageParagraphComponent,
        ImageSpotlightComponent,
        ParagraphComponent,
        QuoteComponent,
        SpacerComponent,
        SubheadingComponent,
        TitleComponent,
        VideoComponent,
        LiveProjectComponent,
    ],
    exports: [
        BuildingBlockComponent,
        CallToActionComponent,
    ],
})
export class BuildingBlocksModule {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/building-blocks.module.ts